import React from "react";
import { Progress } from "radix-ui";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixLoading = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Loading" : _b, className = _a.className, _c = _a.fullScreen, fullScreen = _c === void 0 ? false : _c, icon = _a.icon, iconAction = _a.iconAction;
    var uiTheme = useDataUiTheme();
    var iconClassName = iconAction === "rotate" ? "radix-loading-icon--rotate" : "";
    return (React.createElement("div", { className: ["radix-loading", fullScreen ? "radix-loading--full-screen" : "", className !== null && className !== void 0 ? className : ""].filter(Boolean).join(" "), role: "status", "aria-live": "polite", "data-ui-theme": uiTheme },
        icon ? React.createElement("span", { className: ["radix-loading-icon", iconClassName].filter(Boolean).join(" "), "aria-hidden": "true" }, icon) : null,
        React.createElement("span", { className: "radix-loading-label" }, label),
        React.createElement(Progress.Root, { className: "radix-loading-root", value: 100 },
            React.createElement(Progress.Indicator, { className: "radix-loading-indicator" }))));
};
